import {inject, injectable} from "inversify";
import SERVICE_IDENTIFIER from "../constants/identifiers";
import SystemConfig, {CONFIG_PARAMS, MODES} from "../system/SystemConfig";
import Settings from "../settings/Settings";
import events from "../events/EventsObservable";
import {EVENTS} from "../events/baseEvents";
import Connect from "../connect/Connect";
import AbstractUI from "../ui/AbstractUI";
import InitWallet from "../wallet/InitWallet";
import IErrorHandler from "../error/IErrorHandler";
import CommanderBase from "../commander/CommanderBase";
import MadmaxMessage from "../ui/messages/MadmaxMessage";
import {translate} from "../translations/translations";
import {mobileAndTabletCheck} from "../device/device";
import MobileDOM from "../ui/mobile/MobileDOM";
import IDOM from "../ui/IDOM";
import {BASE_ELEMENT_IDS} from "../ui/BaseDOM";
import UIMessages from "../ui/messages/UIMessages";
import AbstractUIActions from "../ui/AbstractUIActions";
import gameset from "../../../src/gameset";
import { ERROR_CODES } from "../error/errorCodes";
import { errorFactroy } from "../error/MadmaxError";

@injectable()
export default class Replay {
    private config: SystemConfig;
    private connect: Connect;
    private ui: AbstractUI;
    private initWallet: InitWallet;
    private errorHandler: IErrorHandler;
    private commander: CommanderBase;
    private msg: MadmaxMessage;
    private dom: IDOM;
    private uiMessages: UIMessages;
    private uiActions: AbstractUIActions;

    constructor(
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
        @inject(SERVICE_IDENTIFIER.Connect) connect: Connect,
        @inject(SERVICE_IDENTIFIER.ErrorHandler) errorHandler: IErrorHandler,
        @inject(SERVICE_IDENTIFIER.UI) ui: AbstractUI,
        @inject(SERVICE_IDENTIFIER.InitWallet) initWallet: InitWallet,
        @inject(SERVICE_IDENTIFIER.Commander) commander: CommanderBase,
        @inject(SERVICE_IDENTIFIER.DOM) dom: IDOM,
        @inject(SERVICE_IDENTIFIER.UIMessages) uiMessages: UIMessages,
        @inject(SERVICE_IDENTIFIER.UIActions) uiActions: AbstractUIActions
    ) {
        this.config = config;
        this.connect = connect;
        this.errorHandler = errorHandler;
        this.ui = ui;
        this.initWallet = initWallet;
        this.commander = commander;
        this.dom = dom;
        this.uiMessages = uiMessages;
        this.uiActions = uiActions;

        if (this.config.get(CONFIG_PARAMS.MODE) === MODES.REPLAY) {
            // create replay countdown message
            this.createMessage();
            this.uiActions.unsetAllowedActions();

            // set text 'REPLAY MODE' to warning box
            if (mobileAndTabletCheck()) {
                // (this.dom as MobileDOM).createWarning();
                let warn = $(`#${BASE_ELEMENT_IDS.INFO_BOX_WARNING}`);
                warn.text("REPLAY MODE");
                warn.css("color", "white");
            }

            // add class 'replay' to wrapper
            document.getElementById(BASE_ELEMENT_IDS.WRAPPER).classList.add("replay");
        }
    }

    async init(params: any, settings: Settings) {
        let logic, round;
        try {
            logic = await this.connect.logic(params);
            round = await this.connect.replay(params);
            if(gameset.game_id !== round.getData().game_id) {
                throw errorFactroy({code: ERROR_CODES.ROUND_NOT_FOUND});
            }
        } catch (e) {
            await this.errorHandler.handleError(e);
            return Promise.reject(e);
        }
        this.uiActions.unsetAllowedActions();
        round.initReplay(logic, this.config.get(CONFIG_PARAMS.BEHAVIOR));
        this.config.set(CONFIG_PARAMS.GAME_SPECIFICS, round.getGameSpecifics());
        this.config.set(CONFIG_PARAMS.REPLAY_RESULT, round);
        if(!this.config.useLangURL) {
            if(this.config.get(CONFIG_PARAMS.LANGUAGE) === 'en' && settings.getData().legislation) {
                if (settings.getData().legislation === "cze" || settings.getData().legislation === "cz")
                    this.config.set(CONFIG_PARAMS.LANGUAGE, "cs")
                //@ts-expect-error
                if (window.Translations.translations[settings.getData().legislation.toLowerCase()])
                    this.config.set(CONFIG_PARAMS.LANGUAGE, settings.getData().legislation.toLowerCase())
            }
        }

        this.config.initReplay(logic, round);
        await this.initWallet.initReplay(round, settings);
        this.ui.init();
        await events.dispatch(EVENTS.INIT_SUCCESS, round);
    }

    async run() {
        if (this.config.get(CONFIG_PARAMS.MODE) === MODES.REPLAY) {
            this.uiActions.unsetAllowedActions();
            await this.showMessage();
            await this.commander.spin();
        }
    }

    createMessage() {
        this.msg = new MadmaxMessage(
            "", "",
            {},
            this.config.get(CONFIG_PARAMS.LANGUAGE),
            undefined,
            100,
            this.config
        );
        this.msg.create();
        this.uiMessages.addMessage(this.msg);
    }

    async showMessage() {
        this.msg.openMessage();
        await this.countdown();
        this.msg.closeMessage();
        this.msg.destroy();
    }

    async countdown() {
        let text = translate("replay_start", this.config.get(CONFIG_PARAMS.LANGUAGE));
        for (let i = 5; i > 0; i--) {
            await new Promise(res => {
                this.msg.setContent(text + "<br>" + i.toString());
                setTimeout(res, 1000);
            })
        }
    }
}